// @ts-nocheck
import SceneLayerTile from "./tile";

export default class SceneLayerPano extends SceneLayerTile {
	/**
	 * Vytvoreni vrstvy pro panoramu.
	 *
	 * @param  {String|Number} id ID vrstvy
	 * @param  {String} url URL zdroje podkladu
	 * @param  {Object} options Konfigurace
	 */
	constructor(scene, itemId, id, url, options) {
		super(scene, itemId, id, url, options);

		this._avail = {}; /* cache dostupnosti */
		this._ss = [];

		// signal
		this._ss.push(this._scene.addListener("pano-availCheck", event => {
			this._avail = event.data.avail;
		}, this, this));
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		this._scene.removeListeners(this._ss);

		super.destroy();
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerPano",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.avail = this._avail;

		return rd;
	}

	/**
	 * Ziskani dostupnosti.
	 *
	 * @return {Object}
	 */
	getAvail() {
		return this._avail;
	}

	/**
	 * Nastaveni aktivnich bodu
	*/
	setLine(...args) {
		this._onChange(this._scene.featureEvent("layerPanoSetLine", true, true), args);
	}
}
